import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

lessRequire('modules/statistics/components/groups/main.less');

const Groups = ({ groups, groupsChooseItem, groupsSwitchOrder, intl }) => {
	const [firstSelectParams, secondSelectParams] = groups.selectControlsParams;

	return (
		<div className="group-wrap clearfix">
			{renderSelect(firstSelectParams, groupsChooseItem, intl)}
			<div
				className="switch-group"
				onClick={() => {
					groupsSwitchOrder();
				}}
			/>
			{renderSelect(secondSelectParams, groupsChooseItem, intl)}
		</div>
	);
};

const renderSelect = (params, onChooseItem, intl) => {
	return (
		<div className={params.value ? 'select active' : 'select'}>
			<Select
				name={params.name}
				placeholder={intl(params.placeholder)}
				value={params.value}
				options={params.options.map(item => ({ value: item.value, label: intl(item.label) }))}
				searchable={params.searchable}
				clearable={params.clearable}
				onChange={selected => {
					onChooseItem(params.id, selected);
				}}
			/>
		</div>
	);
};

Groups.propTypes = {
	groups: PropTypes.object,
	groupsChooseItem: PropTypes.func,
	groupsSwitchOrder: PropTypes.func,
	intl: PropTypes.func
};

export default Groups;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/groups/main.js